import { Route, Routes } from 'react-router';
import { Game } from './components/Game';
import { GameLinkPage } from './components/GameLinkPage';
import { LandingPage } from './components/LandingPage';
import { LanguageToggle } from './components/LanguageToggle';
import { NotFoundPage } from './components/NotFoundPage';
import { SpymasterView } from './components/SpymasterView';
import { ThemeToggle } from './components/ThemeToggle';
import { LanguageProvider, useTranslation } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
// Import Firebase test
import './test-firebase';

const AppContent = () => {
  const { isRTL } = useTranslation();

  // Set document direction
  document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');

  return (
    <>
      <ThemeToggle />
      <LanguageToggle />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/start-game" element={<GameLinkPage />} />
        <Route path="/game" element={<Game />} />
        <Route path="/spymaster" element={<SpymasterView />} />
        <Route path="/board/:boardId" element={<Game />} />
        <Route path="/404" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
